<template>
  <b-card no-body tag="article" class="mb-2 c-pointer" @click="onClickJob">
    <div class="image-container">
      <b-img-lazy
        class="border-0 rounded-0"
        v-bind="mainProps"
        :src="job.photos ? job.photos[0].url : ''"
      ></b-img-lazy>
    </div>

    <div class="card-details-container p-3">
      <b-card-title class="font-weight-bold">
        <div class="d-flex w-100 justify-content-between">
          <div>{{ job.title }}</div>
          <div>${{ job.price_offer }}</div>
        </div>
      </b-card-title>

      <div class="d-flex w-100 justify-content-between">
        <div>
          <b-card-sub-title class="mb-2">{{ job.suburb }}</b-card-sub-title>
          <b-card-sub-title class="small mt-1">
            <!-- eslint-disable-next-line -->
            {{ job.addedDate }}
          </b-card-sub-title>
        </div>
        <b-img
          :src="require('@/assets/icons/three-dots-secondary.svg')"
          @click.stop="onClickJob"
          v-if="$router.currentRoute.name === 'job.my-jobs-page'"
        ></b-img>
        <b-img
          :src="
            job.is_favorite
              ? require('@/assets/icons/heart-fill-red.svg')
              : require('@/assets/icons/heart-outline-secondary.svg')
          "
          @click.stop="onClickSave"
          v-else
        ></b-img>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      mainProps: {
        center: true,
        blank: true,
        height: '250px',
        width: 'auto'
      }
    }
  },

  methods: {
    ...mapActions({
      saveJob: 'job/saveJob',
      unsaveJob: 'job/unsaveJob'
    }),

    onClickJob() {
      this.$router.replace({
        name: 'job.view-job-page',
        params: {
          id: this.job.id,
          title: this.job.title.replace(/ +/g, '-').toLowerCase()
        }
      })
    },

    async onClickSave() {
      if (this.job.is_favorite) {
        await this.unsaveJob(this.job.id)
      } else {
        await this.saveJob(this.job.id)
      }
      this.job.is_favorite = !this.job.is_favorite
    }
  }
}
</script>

<style lang="scss" scoped>
.card:hover {
  box-shadow: 0px 4px 12px #00000014;
}
.image-container {
  background-color: black;
}
.card-details-container {
  background-color: white;
}
</style>
